import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatImage } from '@ifeng/public_method';
import styles from './index.css';

// 兼容slide文章类型
class SlideArea extends PureComponent {
    static propTypes = {
        slideData: PropTypes.object,
    };

    render() {
        let {
            slideData: { image = [] },
        } = this.props;

        if (Object.prototype.toString.call(image) !== '[object Array]') {
            image = [];
        }

        return image.map((item, index) => (
            <p key={`slide_${index}`} className={styles.textLine}>
                {item.url ? <img src={formatImage(item.url, item.width, item.height)} /> : null}
                <br />
                {item.description}
            </p>
        ));
    }
}

export default errorBoundary(SlideArea);
